module.exports = __webpack_public_path__ + "static/media/hamburger-icon.22b58260.svg";